import React, { useEffect, useState } from 'react';
import axiosInstance from '../../../../http-common';
import { DatePicker } from 'rsuite';

// import React, { useState } from 'react';
// ... other imports

const PoDatePicker = ({
  id,
  field,
  row,
  rowNode,
  colDef,
  cellMode,
  hasFocus,
  tabIndex,
  value,
  formattedValue,
  isEditable,
  api,
}) => {
  const [dt, setDt] = useState(null);

  useEffect(() => {
    // only set date when it's truthy
    if (row[field]) {
      // console.log(row[field]);
      setDt(new Date(row[field]));
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleChange = async (e) => {
    const date = new Date(e);
    const dd = date.getDate();
    const mm = date.getMonth();
    const yyyy = date.getFullYear();
    const hh = date.getHours();
    const min = date.getMinutes();
    const ss = date.getSeconds();

    const d = field === "receiving_date_by_qc" ? `${yyyy}-${mm + 1}-${dd}T${hh}:${min}:${ss}.000Z` : `${yyyy}-${mm + 1}-${dd} ${hh}:${min}:${ss}`;
    const { batch_no, sample_type } = row;
    console.log(api, field);
    console.log(field, row);
    const body = {
      batch_no,
      [field]: d
    };
    try {
      const response = await axiosInstance.patch(`/v1/qc/open_po_new/${sample_type}/`, body);
      const result = (await response)?.data;
      console.log({ result });
      const status = result?.status;
      console.log({ status });
      if (status === "success") {
        api?.updateRows([{ id, [field]: e }]);
        setDt(date);
        console.log({ d });
      }
    } catch (error) {
      console.log({ error });
    }
  };

  return (
    <div>
      <DatePicker
        format='yyyy-MM-dd HH:mm'
        calendarDefaultDate={dt}
        style={{ width: 200 }}
        value={dt}
        onChange={handleChange}
      />
    </div>
  );
};

export default PoDatePicker;